<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدیریت ارزش‌های حرفه‌ای شغل</h4>
    </div>
    <div class="card-body">
      <div class="job-professional-row mb-3">
        <div>
          <label class="form-label fw-bold">عنوان ارزش</label>
          <select class="form-select" v-model="newItem.title">
            <option value="" disabled>عنوان را انتخاب کنید</option>
            <option v-for="(title, index) in titles" :key="index" :value="title">
              {{ title }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">محرک‌های مورد سنجش</label>
          <input
              type="text"
              class="form-control"
              placeholder="محرک را وارد کنید"
              v-model="newItem.stimuli_to_be_measured"
          />
        </div>
        <div>
          <label class="form-label fw-bold">توصیف محرک</label>
          <input
              type="text"
              class="form-control"
              placeholder="توصیف را وارد کنید"
              v-model="newItem.stimulus_description"
          />
        </div>
        <div>
          <label class="form-label fw-bold">وضعیت</label>
          <select class="form-select" v-model="newItem.status">
            <option value="" disabled>وضعیت را انتخاب کنید</option>
            <option v-for="(status, index) in statuses" :key="index" :value="status">
              {{ status }}
            </option>
          </select>
        </div>
        <div>
          <GeneralButton @clicked="addItem"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- Items Table -->
      <GeneralTable
          :headers="['عنوان ارزش', 'محرک‌های مورد سنجش', 'توصیف محرک', 'وضعیت']"
          :fields="['title', 'stimuli_to_be_measured', 'stimulus_description', 'status']"
          :items="professionalValues"
          :openEditModalMethod="openEditModal"
          @remove="removeItem"
      />

      <!-- Edit Item Modal -->
      <GeneralModal
          v-show="editedItem"
          :title="'ویرایش ارزش حرفه‌ای شغل'"
          modal-id="jobValueModalId"
          @save="updateItem"
      >
        <div class="row mb-3">
          <div class="col-md-6">
            <label class="form-label fw-bold">عنوان ارزش</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.title">
              <option value="" disabled>عنوان را انتخاب کنید</option>
              <option v-for="(title, index) in titles" :key="index" :value="title">
                {{ title }}
              </option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">محرک‌های مورد سنجش</label>
            <input
                type="text"
                class="form-control"
                placeholder="محرک را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.stimuli_to_be_measured"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">توصیف محرک</label>
            <input
                type="text"
                class="form-control"
                placeholder="توصیف را وارد کنید"
                v-if="editedItem"
                v-model="editedItem.stimulus_description"
            />
          </div>
          <div class="col-md-6">
            <label class="form-label fw-bold">وضعیت</label>
            <select class="form-select" v-if="editedItem" v-model="editedItem.status">
              <option value="" disabled>وضعیت را انتخاب کنید</option>
              <option v-for="(status, index) in statuses" :key="index" :value="status">
                {{ status }}
              </option>
            </select>
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  title: '',
  stimuli_to_be_measured: '',
  stimulus_description: '',
  status: ''
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  created() {
    this.$store.dispatch('crudActions/fetchInitialData', {
      endpoint: '/job-professional-values/index',
      afterMutation: 'jobProfessionalValues/setProfessionalValues'
    });
  },
  data() {
    return {
      newItem: structuredClone(baseStructure),
      statuses: {veryHigh: "خیلی زیاد", high: "زیاد", medium: "متوسط", low: "کم", veryLow: "خیلی کم"},
      titles: ['گرایش به نتیجه', 'شرایط خوب کاری', 'اعتبار شغلی', 'ارتباطات گسترده', 'برخورداری از حمایت', 'استقلال در کار'],
      editedItem: null,
      editIndex: null,
    };
  },
  computed: {
    professionalValues: {
      get() {
        return this.$store.state.jobProfessionalValues.professionalValues;
      },
      set(value) {
        return this.$store.commit('jobProfessionalValues/setProfessionalValues', value);
      }
    },
  },
  methods: {
    async addItem() {
      if (!this.newItem.title || !this.newItem.stimuli_to_be_measured || !this.newItem.stimulus_description || !this.newItem.status) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newItem,
        endpoint: '/job-professional-values/store',
      })

      this.professionalValues = [...this.professionalValues, structuredClone(response.data)];
      this.newItem = structuredClone(baseStructure);
    },
    removeItem(index) {
      const professionalValue = this.professionalValues.find((_, i) => i === index);
      this.professionalValues = this.professionalValues.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: professionalValue.id,
        endpoint: '/job-professional-values/delete',
      })
    },
    openEditModal(item, index) {
      this.editedItem = structuredClone(item);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('jobValueModalId'));
      modal.show();
    },
    updateItem() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedItem.title || !this.editedItem.stimuli_to_be_measured || !this.editedItem.stimulus_description || !this.editedItem.status) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.professionalValues.splice(this.editIndex, 1, {...this.editedItem});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedItem,
        endpoint: '/job-professional-values/update',
      })

      this.editIndex = null;
      this.editedItem = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('jobValueModalId'));
      modal.hide();
    }
  }
}
</script>
